import axios from 'axios'
import { getCookie } from '../api/cookies'

export const baseURL =
  process.env.REACT_APP_BASE_URL || 'https://api.attendance.inflection.org.in/'

export const siteBaseURL = process.env.REACT_APP_SITE_URL

let apiClient = axios.create({
  baseURL,
  withCredentials: false,
  timeout: 55000,
  headers: {
    authorization: `Bearer ${getCookie('token')}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

const setAuthHeader = (tokenName) => {
  apiClient = axios.create({
    baseURL,
    withCredentials: false,
    timeout: 30000,
    headers: {
      authorization: `Bearer ${getCookie(tokenName)}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
}
// ---------------- Form Data axios configurations -----------
let formDataApiClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${getCookie('token')}`,
  },
  timeout: 60000,
})

const setFormDataAuthHeader = () => {
  formDataApiClient = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${getCookie('token')}`,
    },
    timeout: 60000,
  })
}

const updateEmployeeImage = (id, payload) => {
  return apiClient.patch(`/employees/${id}/photo`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data', // Optional, but Axios will handle it if omitted
    },
  })
}

// ------------------ User -----------------------

const login = (payload) => {
  return apiClient.post('/login', payload)
}
// const resetPassword = (token, payload) => {/
//   return apiClient.patch(`/users/reset_password/${token}`, payload)
// }
// const forgotPassword = (payload) => {
//   return apiClient.post('/users/forgot_password', payload)
// }

// const renewAccessToken = () => {
//   return apiClient.get('/users/renew_token')
// }

// const getMyProfile = () => {
//   return apiClient.get('/users/profiles/my')
// }

// ************************Employee*******************************
const addEmployee = (payload) => {
  return apiClient.post('/employees', payload)
}
const getAllEmployees = () => {
  return apiClient.get('/employees')
}
const getAEmployee = (id) => {
  return apiClient.get(`/employees/${id}`)
}
const deleteEmployees = (id) => {
  return apiClient.delete(`/employees/${id}`)
}
const updateEmployee = (id, payload) => {
  return apiClient.patch(`/employees/${id}`, payload)
}
const deleteEmployeeImage = (id) => {
  return apiClient.delete(`/employee/${id}/photo`)
}
const enrollEmployee = (id) => {
  return apiClient.patch(`/employees/${id}/enroll`)
}
const deleteEmployee = (id) => {
  return apiClient.delete(`/employees/${id}/enroll`)
}
// *************************Holiday*************************
const addHolidays = (payload) => {
  return apiClient.post('/holidays', payload)
}
const getHolidays = (from, to) => {
  return apiClient.get(`/holidays?from=${from}&to=${to}`)
}
const deleteHolidays = (id) => {
  return apiClient.delete(`/holidays/${id}`)
}
// ***************************Attendance**********************
const getAllAttendances = (from, to) => {
  return apiClient.get(`/attendances?from=${from}&to=${to}`)
}
const getOneAttendances = (id, from, to) => {
  return apiClient.get(`/attendances/${id}/one?from=${from}&to=${to}`)
}
const addCoustomAttendance = (payload) => {
  return apiClient.post('/attendances', payload)
}
const deleteAttendance = (id) => {
  return apiClient.delete(`/attendances/${id}`)
}
const getLeaveStatus = (id) => {
  return apiClient.get(`/employees/${id}/leave_status`)
}
const getMonthlySummary = (id, year_month) => {
  return apiClient.get(
    `/employees/${id}/month_attendance?month_year=${year_month}`
  )
}
// *******************Leave policy*********************
const addLeavePolicy = (payload) => {
  return apiClient.post('/leave_policies', payload)
}
const getLeavePolicy = () => {
  return apiClient.get('/leave_policies/')
}
const updateLeavePolicy = (type, payload) => {
  return apiClient.patch(`/leave_policies/${type}`, payload)
}
const deleteLeavePolicy = (type) => {
  return apiClient.delete(`/leave_policies/${type}`)
}
// *************************salary*********************
const generateSalarySlip = (id, month, year, percentage, bonus, penalty) => {
  return apiClient.post(
    `/salaries/slip/generate/${id}?month=${month}&year=${year}&tax_percentage=${percentage}&bonus=${bonus}&penalty=${penalty}`
  )
}
const calculateMonthSalary = (id, month, year, percentage, bonus, penalty) => {
  return apiClient.get(
    `/salaries/calculate/${id}?month=${month}&year=${year}&tax_percentage=${percentage}&bonus=${bonus}&penalty=${penalty}`
  )
}
const getSalarySlipByMonth = (month, year) => {
  return apiClient.get(`/salaries/slips?month=${month}&year=${year}`)
}
const getSalarySlipEmployee = (id, month, year) => {
  return apiClient.get(`/salaries/slips/${id}?month=${month}&year=${year}`)
}
const deleteEmployeeSalary = (id) => {
  return apiClient.delete(`/salaries/slip/${id}`)
}
const editEmployeeSalary = (id, payload) => {
  return apiClient.patch(`/salaries/slip/${id}`, payload)
}
// **************DashBoard*************************
const getDashBoard = () => {
  return apiClient.get('/dashboard/')
}

export {
  setAuthHeader,
  setFormDataAuthHeader,
  login,
  addEmployee,
  getAllEmployees,
  addHolidays,
  getHolidays,
  deleteHolidays,
  getAllAttendances,
  addCoustomAttendance,
  deleteAttendance,
  getAEmployee,
  updateEmployee,
  updateEmployeeImage,
  deleteEmployeeImage,
  getOneAttendances,
  enrollEmployee,
  deleteEmployee,
  deleteEmployees,
  addLeavePolicy,
  getLeavePolicy,
  updateLeavePolicy,
  deleteLeavePolicy,
  generateSalarySlip,
  calculateMonthSalary,
  getSalarySlipByMonth,
  getSalarySlipEmployee,
  getLeaveStatus,
  getMonthlySummary,
  deleteEmployeeSalary,
  editEmployeeSalary,
  getDashBoard,
}
